/* eslint-disable */

import React from "react";
import IsYouBirthdayPalindrome from "../features/is-your-birthday-palindrome/view";

function Section() {
  return <IsYouBirthdayPalindrome />;
}

export default Section;
